import * as globalNavConstants from '~coreModules/nav/js/nav-constants';

export const NAV_CHANNELS = {
    ...globalNavConstants.NAV_CHANNELS,
    SUBSCRIBER: 'subscriber',
    NON_SUBSCRIBER: 'nonsubscriber',
};

export const BROWSE_COLLECTION_PARENT_SLUG = 'collections';
